/** @format */

import React, { useState, useEffect } from "react";
import Tabs from "../../../components/Tabs";
import ContentTop from "../../../components/ContentTop";
import Page1 from "./Page1";
import Page2 from "./Page2";
import Page3 from "./Page3";
import Page4 from "./Page4";

const AmudaryoSahifa = () => {
  const [toggle, setToggle] = useState(3);

  const tabs = [
    { title: "Jadval", id: 3, type: "text" },
    { title: "Diagramma", id: 1, type: "text" },
    { title: "Sxema", id: 2, type: "text" },
    { title: "location", id: 4, type: "location" },
  ];

  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const [ldate, setLdate] = useState(date);
  const [month, setMonth] = useState(new Date().toISOString().slice(0, 7));
  const [lmonth, setLmonth] = useState(month);

  useEffect(() => {
    setMonth(lmonth);
  }, [lmonth]);

  useEffect(() => {
    setDate(ldate);
  }, [ldate]);

  const pages = (t) => {
    switch (t) {
      case 1:
        return <Page1 date={date} />;
      case 2:
        return <Page2 date={date} />;
      case 3:
        return <Page3 month={month} />;
      case 4:
        return <Page4 date={date} />;
      default:
        return <Page3 month={month} />;
    }
  };

  return (
    <div className='amudaryo'>
      <ContentTop>
        <ul className='content-top-left'>
          <li>Amudaryo balansi</li>
          <div>
            <Tabs toggle={toggle} setToggle={setToggle} tabs={tabs} />
          </div>
        </ul>

        <div className='content-top-right'>
          {toggle === 3 || toggle === 5 ? (
            <input
              type='month'
              className='form-control form-control-sm'
              onChange={(e) => setLmonth(e.target.value)}
              value={lmonth}
            />
          ) : (
            <input
              type='date'
              className='form-control form-control-sm'
              onChange={(e) => setLdate(e.target.value)}
              value={ldate}
            />
          )}
        </div>
      </ContentTop>

      <div className='tabs-content table-box extra-tab-css'>
        <div className='tabs-content-item active'>{pages(toggle)}</div>
      </div>
    </div>
  );
};

export default AmudaryoSahifa;
